import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import BCXLazy from '@/components/molecules/BCXLazy.vue';
import BCXLinkedUser from '@/components/molecules/BCXLinkedUser.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import Reporting from '@/components/voting/Reporting.vue';
import Voting from '@/components/voting/Voting.vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import useI18n from '@/mixins/useI18n';

import {
  Chat, CHAT_TYPE_FORUM, CHAT_TYPE_GROUP, CHAT_TYPE_PROJECT, ChatMessage, MESSAGE_EVENT_SET_TEXT, TEMPORARY_CHAT_USER_ID
} from '@/models/Messenger';
import { User } from '@/models/User';
import useMessengerState from '@/state/messenger/messengerState';
import userFromState from '@/state/messenger/userFromState';
import {
  computed, PropType, Ref, toRefs, watchEffect
} from 'vue';
import { createVuexHelpers } from 'vue2-helpers';
import eventBus from '@/state/messenger/EventBus';
import useUser from '@/mixins/useUser';
import { templateRef, useDocumentVisibility, useElementVisibility } from '@vueuse/core';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerChatMessage',
  props: {
  message: {
    type: Object as PropType<ChatMessage>,
    default: () => null,
  },
  chat: {
    type: Object as PropType<Chat>,
    default: () => null,
  },
  areInitialMessagesShown: {
    type: Boolean
  },
  // Render the text without BCXLazy (prepended history pages).
  eager: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props;



const {
  markAsRead, editMessageId, sendingMessageId, joinChatGroup
} = useMessengerState();
const { getFormattedTimeByAge } = useFormattedDateTime();
const { message, chat } = toRefs(props);
const { useGetters } = createVuexHelpers();
const { user } = useGetters(['user']) as {
      user: Ref<User>;
    };

const i18n = useI18n();

const isTemporary = computed(() => message.value.creator === TEMPORARY_CHAT_USER_ID);
const isMe = computed(() => user.value.userId === message.value.creator || isTemporary.value);

const el = templateRef<HTMLElement>('el');

const messageCreator = computed<User | null>(() => {
  if (chat.value?.type === CHAT_TYPE_GROUP) {
    const { creator } = message.value;
    if (!creator || creator === TEMPORARY_CHAT_USER_ID) return null;
    return userFromState(creator);
  }
  return chat.value?.privatePartner ?? null;
});

const { informalName, displayName } = useUser(messageCreator);

const created = computed(() => getFormattedTimeByAge(message.value?.created));

const text = computed(() => message.value.text);

const isMessageVisible = useElementVisibility(el);
const isDocumentVisible = useDocumentVisibility();

watchEffect(() => {
  // Group messages are marked read group-wide (markGroupRead), not per message.
  if (isMessageVisible.value && isDocumentVisible.value && !message.value.read
    && chat.value?.type !== CHAT_TYPE_GROUP) {
    markAsRead(message.value);
  }
});

const edit = () => {
  const { messageId } = message.value;
  editMessageId.value = messageId === editMessageId.value ? '' : messageId;
};

const showDownVote = computed(() => chat.value.type === CHAT_TYPE_FORUM || chat.value.type === CHAT_TYPE_PROJECT);

const isBeingSent = computed(() => sendingMessageId.value === message.value.messageId);

const isBeingEdited = computed(() => editMessageId.value === message.value.messageId && !isBeingSent.value);

const isEdited = computed(() => message.value.edited);

const creatorLabel = computed(() => {
  if (isMe.value) return i18n.t('messenger.chat.me');
  return chat.value?.type === CHAT_TYPE_GROUP ? displayName.value : informalName.value;
});

const canEdit = computed(() => isMe.value && !isTemporary.value && !isBeingSent.value);

const canFlag = computed(() => !isMe.value);

const getFailedText = () => {
  eventBus.emit(MESSAGE_EVENT_SET_TEXT, message.value?.text ?? '');
};

const { openCalendar } = useMeetingScheduler();


return { __sfc: true,props, markAsRead, editMessageId, sendingMessageId, joinChatGroup, getFormattedTimeByAge, message, chat, useGetters, user, i18n, isTemporary, isMe, el, messageCreator, informalName, displayName, created, text, isMessageVisible, isDocumentVisible, edit, showDownVote, isBeingSent, isBeingEdited, isEdited, creatorLabel, canEdit, canFlag, getFailedText, openCalendar, BCXItemsWithPoints, BCXLazy, BCXLinkedUser, BCXMarkdown, Reporting, Voting }
}

})